import { createApp } from '@app/adapters/create-app'
import BudgetSetImportsButton from '../sections/budget-set-imports-button.vue'

onDomLoad(() => {
  document
    .querySelectorAll("[data-behaviour='budget-set-import']")
    .forEach((el) => {
      const data = el.dataset

      createApp(BudgetSetImportsButton, {
        allowedFilenameExtensions: data.allowedFilenameExtensions,
        analyticalDimensionsSelected: data.analyticalDimensionsSelected,
        budgetSetId: parseInt(data.budgetSetId),
        budgetSetName: data.budgetSetName,
        company: {
          id: parseInt(Silverfin.currentCompanyId),
          firmId: parseInt(Silverfin.currentFirmId),
        },
        entriesFilter: JSON.parse(data.entriesFilter),
        firstPeriod: data.firstPeriod,
        hasAnalyticalDimensions: JSON.parse(data.hasAnalyticalDimensions),
        lastPeriod: data.lastPeriod,
        text: data.text,
      }).mount(el)
    })
})
